import { INotification } from './NotificationInterface';
import { getLocalizationValues } from '../utils/utils';

export interface IModelInputItem {
  id?: string;
  type?: string;
  application?: string;
  title?: string;
  subject?: string;
  body?: string;
  userSpecific?: boolean;
}

export interface INotificationInsightsResponse {
  summary: string;
}

const stripTags = (html?: string): string =>
  (html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const linkifySummary = (
  summary: string,
  notifications: INotification[],
  getLabel: (n: INotification) => string
): string => {
  if (!summary) return summary;
  if (summary.includes('notification:')) return summary;
  let out = summary;
  (notifications || []).forEach((n) => {
    if (!n.messageId || !out.includes(n.messageId)) return;
    const label = (getLabel(n) || 'notification')
      .replace(/[[\]()]/g, '')
      .trim();
    const escapedId = n.messageId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    out = out.replace(
      new RegExp(escapedId, 'g'),
      `[${label}](notification:${n.messageId})`
    );
  });
  return out;
};

export const notificationsSignature = (notifications: INotification[]): string =>
  (notifications || [])
    .map((n) => n.messageId)
    .filter(Boolean)
    .sort()
    .join('|');

export const toModelInput = (
  notifications: INotification[],
  locale?: string
): IModelInputItem[] =>
  (notifications || []).map((n) => {
    const localized = getLocalizationValues(locale || 'en_US', n);
    return {
      id: n.messageId,
      type: n.type,
      application: n.application,
      title: stripTags(localized.title),
      subject: stripTags(localized.subject),
      body: stripTags(localized.body),
      userSpecific: !!n.target?.loginId,
    };
  });

export const parseInsightsResponse = (
  data: any
): INotificationInsightsResponse => {
  if (typeof data === 'string') {
    const cleaned = data
      .trim()
      .replace(/^```(?:json)?/i, '')
      .replace(/```$/, '')
      .trim();
    try {
      return JSON.parse(cleaned);
    } catch {
      return { summary: '' };
    }
  }
  return data || { summary: '' };
};
